import { NgModule } from "@angular/core";
import {
	DefaultDataServiceConfig,
	EntityActionFactory,
	EntityCache,
	EntityCacheDataService,
	EntityDataModule,
	EntityDataService,
} from "@ngrx/data";
import { EffectsModule } from "@ngrx/effects";
import { routerReducer, StoreRouterConnectingModule } from "@ngrx/router-store";
import { Store, StoreModule } from "@ngrx/store";
import { entityConfig } from "./entity-metadata";
import { entityModuleImports } from "./entity.module.imports";
import { ListingHistoryDataService } from "./history/listing-history-data.service";
import { ListingMediaDataService } from "./media/listing-media-data.service";
import { ListingMediaAuditDataService } from "./media/media-history/listing-media-audit-data.service";
import { NstarCacheDataService } from "./nstar-cache-data.service";
import { OpenHouseDataService } from "./open-houses/open-house-data.service";
import { ListingSummaryDataService } from "./shared/services/listing-summary-data.service";
import { ListingAuditDataService } from "./history/listing-audit-data.service";
import { OpenHouseAuditDataService } from "./open-houses/components/open-house-history/open-house-history-data.service";
@NgModule({
	imports: [
		StoreModule.forRoot({ router: routerReducer }, {}),
		EffectsModule.forRoot([]),
		StoreRouterConnectingModule.forRoot(),
		...entityModuleImports,
		EntityDataModule.forRoot(entityConfig),
	],
	providers: [
		{
			provide: DefaultDataServiceConfig,
			useValue: {
				root: "api",
				timeout: 3000,
			},
		},
		{ provide: EntityCacheDataService, useClass: NstarCacheDataService },
	],
})
export class EntityModule {
	constructor(
		store: Store<EntityCache>,
		entityActionFactory: EntityActionFactory,
		entityDataService: EntityDataService,
		listingSummaryDataService: ListingSummaryDataService,
		listingMediaDataService: ListingMediaDataService,
		listingMediaAuditDataService: ListingMediaAuditDataService,
		openHouseDataService: OpenHouseDataService,
		openHouseAuditDataService: OpenHouseAuditDataService,
		listingHistoryDataService: ListingHistoryDataService,
		listingAuditDataService: ListingAuditDataService
	) {
		// Register dispatchers with these data services because they have related records.
		// listingSummaryDataService.registerApiResponseCallback()
		// memberDataService.registerApiResponseCallback(dispatcher);

		// Register services with Ngrx Data.
		entityDataService.registerServices({
			ListingSummary: listingSummaryDataService,
			ListingMedia: listingMediaDataService,
			ListingMediaAudit: listingMediaAuditDataService,
			OpenHouse: openHouseDataService,
			OpenHouseAudit: openHouseAuditDataService,
			ListingHistory: listingHistoryDataService,
			ListingAudit: listingAuditDataService,
		});
	}
}
